import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Button, Typography } from '@mui/material'

import styles from './card.module.scss'

interface IProps {
  images: string
  name: string
  link: string
}

export const CatalogCard: React.FC<IProps> = ({ images, name, link }) => {
  const navigate = useNavigate()

  return (
    <Box
      className={styles.root}
      onClick={() => {
        navigate(link)
      }}
    >
      <Box className={styles.media}>
        <img src={images} alt={name} className={styles.cover} loading='lazy' />
      </Box>

      <Typography variant='body1' className={styles.title}>
        {name}
      </Typography>

      <Button
        variant='contained'
        className={styles.btn}
        size='medium'
        onClick={() => {
          navigate(link)
        }}
      >
        Детальніше
      </Button>
    </Box>
  )
}
